export default __webpack_public_path__ + "static/media/hybrid-front.a0a8d8b6.jpg";